import React from 'react';
import {AppLoading} from '../../components/AppLoading';
import {BiProvider} from '../../components/BiProvider/BiProvider';
import {ErrorBoundary} from '../../components/ErrorBoundary';
import {ErrorStatePage} from '../../components/ErrorStatePage/ErrorStatePage';
import {container} from '../../ioc/container';
import {services} from '../../ioc/services';
import {getAlbumAndTrackId} from '../../services/env/getAlbumAndTrackId/getAlbumAndTrackId';
import {ILocationService} from '../../services/LocationService/ILocationService';
import {DataContainer} from '../DataContainer';
import {MechanizedApp} from '../MechanizedApp';
import {PageContainer} from '../PageContainer';

export const AppComponent = () => {
  const location = container.get<ILocationService>(services.location);
  const {albumId, trackId} = getAlbumAndTrackId(location.getSearch(), location.getHash());

  return (
    <BiProvider albumId={albumId}>
      <DataContainer albumId={albumId} loadingComponent={AppLoading} errorComponent={ErrorStatePage}>
        {({album}) => (
          <MechanizedApp album={album} trackId={trackId}>
            <PageContainer />
          </MechanizedApp>
        )}
      </DataContainer>
    </BiProvider>
  );
};

export const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <AppComponent />
    </ErrorBoundary>
  );
};
